module.exports = __webpack_public_path__ + "media/level3-siren.40e3ca61.mp3";